import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-title-bar',
    templateUrl: './title-bar.component.html',
    styleUrls: ['./title-bar.component.scss'],
    imports: [TranslateModule]
})
export class TitleBarComponent implements OnInit {
  @Input() public titleText: string;
  @Input() public set rootBreadCrumbs(value: string[] | string) {
    if (!value) {
      this._rootBreadCrumbs = null;
      return;
    }

    if (typeof value === 'string') {
      value = value.trim();
      if (value.length === 0) {
        this._rootBreadCrumbs = null;
        return;
      }
      if (value.trim()[0] !== '[') {
        this._rootBreadCrumbs = [value];
      } else {
        this._rootBreadCrumbs = value.substring(1, value.length - 1).replace(new RegExp('[\'\"]', 'g'), '').split(',').map(value => value?.trim());
      }
    }
  }

  public get rootBreadCrumbs() {
    return this._rootBreadCrumbs;
  }

  private _rootBreadCrumbs: string[];

  constructor() { }

  ngOnInit() {
  }

}
